import { useAuth } from "../context/AuthContext";

const withAuth = (WrappedComponent) => {
    return function EnhancedComponent(props) {
      const { isLoggedIn, currentUserRole, logout, setCurrentUserRole } = useAuth();
      return <WrappedComponent {...props} isLoggedIn={isLoggedIn}  currentUserRole={currentUserRole} logout={logout} setCurrentUserRole={setCurrentUserRole}/>;
    };
};


export default withAuth;